import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * support (call-markaz): W — inbox (chatlar), so'rovlar, mijozlar, analitika, bot, FAQ, shablonlar,
 * ommaviy xabarlar, sozlamalar; S — hamkor murojaatlari (Keytosell bilan yozishma).
 */
export const workRoutes: RouteObject[] = [
  { path: 'support', ...page(() => import('./pages/InboxPage')) },
  { path: 'support/requests', ...page(() => import('./pages/RequestsPage')) },
  { path: 'support/customers', ...page(() => import('./pages/CustomersPage')) },
  { path: 'support/analytics', ...page(() => import('./pages/AnalyticsPage')) },
  { path: 'support/bot', ...page(() => import('./pages/BotPage')) },
  { path: 'support/faq', ...page(() => import('./pages/FaqPage')) },
  { path: 'support/templates', ...page(() => import('./pages/TemplatesPage')) },
  { path: 'support/broadcasts', ...page(() => import('./pages/BroadcastsPage')) },
  { path: 'support/settings', ...page(() => import('./pages/SettingsPage')) },
];

export const sellerRoutes: RouteObject[] = [{ path: 'support', ...page(() => import('./pages/STicketsPage')) }];
